import {useEffect, useState} from 'react';
import {AuthorBoundary, toolUrls} from './AuthorBoundary';
import {Capacity} from './Capacity';
import {Icon} from './Icon';
import {useAuth} from '../auth';
import {AdminNotice} from '../components';

const WIDE_QUERY = '(min-width: 1440px)';

/** Au-dessous de 1440 px la colonne n'a plus la place : elle se replie sous la barre. */
export function useWideLayout(): boolean {
  const [wide, setWide] = useState(() => typeof window !== 'undefined' && !!window.matchMedia?.(WIDE_QUERY).matches);
  useEffect(() => {
    const media = window.matchMedia?.(WIDE_QUERY);
    if (!media) return;
    const update = () => setWide(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  return wide;
}

const tools: Array<{key: keyof typeof toolUrls; label: string; hint: string}> = [
  {key: 'author', label: 'Author', hint: 'ACL de contenu'},
  {key: 'support', label: 'Support', hint: 'validations'},
  {key: 'backoffice', label: 'Backoffice', hint: 'reporting'},
];

function ContextBody() {
  const {me} = useAuth();
  const links = tools.filter(tool => toolUrls[tool.key]);
  return <>
    <section><h2>Votre session</h2>{me?.admin && <AdminNotice active={me.status === 'active'} />}<Capacity /></section>
    {!!links.length && <section><h2>Outils</h2><div className="tools">
      {links.map(tool => <a key={tool.key} href={toolUrls[tool.key]} target="_blank" rel="noreferrer"><Icon name="ext" size={13} /> {tool.label} <span>{tool.hint}</span></a>)}
    </div></section>}
    <AuthorBoundary />
    <section><h2>Règles</h2><ul className="rules">
      <li>Les modifications passent par un aperçu serveur puis une confirmation.</li>
      <li>Une nouvelle version de profil ne change aucune affectation.</li>
      <li>Vous ne pouvez pas modifier vos propres accès.</li>
    </ul></section>
  </>;
}

export function ContextColumn({folded = false}: {folded?: boolean}) {
  if (folded) return <details className="context-fold"><summary>Session, outils et règles</summary><div className="context"><ContextBody /></div></details>;
  return <aside className="context" aria-label="Contexte de session"><ContextBody /></aside>;
}
